import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {
    MatCheckboxChange,
    MatCheckboxModule
} from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { Address, Provider } from '../../models/provider.model';
import { ProviderSiteComponent } from '../provider-site/provider-site.component';
import { ProviderSiteSelectorComponent } from '../provider-site-selector/provider-site-selector.component';

@Component({
    selector: 'app-provider-card',
    templateUrl: './provider-card.component.html',
    styleUrls: ['./provider-card.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        MatButtonModule,
        TranslocoModule,
        MatExpansionModule,
        MatIcon,
        MatCardModule,
        MatListModule,
        MatTooltipModule,
        MatCheckboxModule,
        ProviderSiteSelectorComponent
    ]
})
export class ProviderCardComponent {
    @Input()
    provider!: Provider;

    @Output()
    selectedEvent: EventEmitter<Provider> = new EventEmitter<Provider>();

    constructor(private readonly _dialog: MatDialog) {}

    singleLineAddress(address: Address): string {
        if (!address) return '';
        var parts = [
            address.streetAddress,
            address.city,
            address.stateCode,
            address.postalCode
        ];
        return parts.join(', ');
    }

    toggleSelected() {
        this.provider.selected = !this.provider.selected;
        this.selectedEvent.emit(this.provider);
    }

    updateSelectedSites(siteIds: number[]): void {
        this.provider.selectedSiteIds = siteIds;
    }

    showAllSiteAddresses() {
        this._dialog.open(ProviderSiteComponent, {
            height: '300px',
            width: '600px',
            data: this.provider
        });
    }
}
